<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G8Epwi/images/e9781439635865_cover.jpg?1684306108087" alt="This image is the cover for the book Navy in San Diego, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Navy in San Diego, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>San Diego has never been afraid to call itself a "Navy Town," and the positive and inspiring link between the navy and the city knows no equal across the country. For over 150 years, beginning with the U.S. Navy's capture of the city for the United States in the opening days of the Mexican War, the navy has been an indelible part of San Diego's lifestyle, culture, and vitality. Not only has the navy formed the bedrock of the region's economy, but it has helped shape the population while endowing the city with a sense of international and cosmopolitan awareness that separates San Diego from many other cities of its size. San Diego and its navy enjoy a special relationship, one deeply rooted in historic perspective that renews itself with each<br/>passing year.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bruce Linder
      </h2>
      
      <p class="authorDescription body article">Bruce Linder is an award-winning naval historian and Annapolis graduate with two previous books on the history of the navy in its principal ports of call. He has assembled a vivid collection of vintage photography of San Diego's naval development from the National Archives, U.S. Navy, and private sources, many never previously published, to present a compelling and little-known story that helps trace the development of the San Diego region itself.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9b8eb41a